import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateWithdrawal, InvoicesState } from "../models/Invoices";
import { AppThunk } from "./store";
import { getOrgId } from "./orgHelpers";
import { setCreateWithdrawalStatus } from "./TransactionSlice";
import { InvoiceService } from "../services/WithdrawalService";
import { openToast, setToastInfo, setToastStatus } from "./ToastSlice";
import { ToastInfo } from "../models/Toast";

const initialState: InvoicesState = {
    organizationsWithdrawals: null
};

const invoicesSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        setOrganizationsWithdrawal : (state, action: PayloadAction<Array<any>>) => {
            state.organizationsWithdrawals = action.payload;
        }
    }
  });
  
export const {
    setOrganizationsWithdrawal,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;

export const createWithdrawal = 
    (payload : CreateWithdrawal ) : AppThunk<Promise<any>> => 
    async (dispatch, getState) => {

        try {

            if (!payload) {
                dispatch(setCreateWithdrawalStatus(false))
                const info : ToastInfo = {
                    title: 'Erro ao criar o saque',
                    message: 'Preencher corretamente os campos',
                    effect: 'warning'
                }
                dispatch(openToast(info));
                //throw new Error('Sem dados para criar o saque');
            }
            const state = getState();
            const withdrawalResponse = await InvoiceService.createWithdrawal(
                payload, 
                state.user.userInfo.id
            );

            if (!withdrawalResponse) {
                //throw new Error('Erro ao criar o saque');
                const info : ToastInfo = {
                    title: 'Erro com saque',
                    message: 'Erro: ' + withdrawalResponse,
                    effect: 'error'
                }
                dispatch(openToast(info));
                dispatch(setCreateWithdrawalStatus(false))
            }

            const info : ToastInfo = {
                    title: 'Sucesso com saque',
                    message: 'Sucesso ao criar o saque, agora so esperar a equipe',
                    effect: 'success'
                }
                dispatch(openToast(info));
            dispatch(setCreateWithdrawalStatus(false))
            return withdrawalResponse

        } catch (e) {
            dispatch(setCreateWithdrawalStatus(false))
            console.error(e);
            throw e;
        }
    }

export const getWithdrawalByOrganization = () : AppThunk<Promise<any>> => async (dispatch, getState) => {
    const state = getState();
    const organizationWithdrawl : any = await InvoiceService.getWithdrawalByOrganization(getOrgId(state))
    dispatch(setOrganizationsWithdrawal(organizationWithdrawl))
}